import React from 'react';
import {LoanServiceConsumer} from '../loan-service-context'
const withLoanService = () => (Wrapped) =>{
    return (props) => {
        return(
            <LoanServiceConsumer>
                {
                    (loanService) => {
                        return (<Wrapped { ...props } loanService = {loanService} />);
                    }
                }
            </LoanServiceConsumer>
        )

    }
};
export default withLoanService;